module.exports = __webpack_public_path__ + "img/40_38_055_380.157526c7.jpg";